import React, { useEffect, useState } from 'react'
import { BrowserRouter, Redirect, Route, Switch } from 'react-router-dom'
import { SignInCallback, SignInRedirectProviders, SignInRedirectPaths } from '@revenuewell/logic-oidc-signin-callback'
import { CriticalError } from '@revenuewell/page-critical-error'
import { AppSpinner, ProgressProvider, useProgress } from '@revenuewell/logic-progress'
import {AppAdminTemplateProviders} from "../app-admin-template-providers/app-admin-template-providers";
import {IAppAdminTemplateProps} from "./types/app-admin-template-props";
import { ProxyProvider } from '@revenuewell/logic-wrapper-proxy'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: false
    },
    mutations: {
      retry: false
    }
  }
})

export function AppAdminTemplate(props: React.PropsWithChildren<IAppAdminTemplateProps>) {
  return (
    <QueryClientProvider client={queryClient}>
      <ProxyProvider>
        <ProgressProvider>
          <AppAdminTemplateBase {...props} />
        </ProgressProvider>
      </ProxyProvider>
    </QueryClientProvider>
  )
}

function AppAdminTemplateBase(props: React.PropsWithChildren<IAppAdminTemplateProps>) {

  const prodConfigPath = props.prodConfigPath ?? "config/config.json"
  const privateRoutes = props.routes.filter((r) => { return r.private })
  const { showAppSpinner } = useProgress()
  const [isActivated, setIsActivated] = useState(false)

  useEffect(() => {
    showAppSpinner()
    setIsActivated(true)
  }, [])

  return <>
    <BrowserRouter>
      <Switch>
        <Route exact path={SignInRedirectPaths}>
          <SignInRedirectProviders
            isProduction={props.isProduction}
            devConfig={props.devConfig}
            prodConfigPath={prodConfigPath}>
            <SignInCallback />
          </SignInRedirectProviders>
        </Route>

        { isActivated &&
          <Route exact path={privateRoutes?.map(r => r.path!)}>
            <AppAdminTemplateProviders {...props}>
              {props.children}
            </AppAdminTemplateProviders>
          </Route>
        }

        <Route exact path='/critical-error'>
          <CriticalError />
        </Route>

        {props.defaultRedirect &&
        <Route exact path="/">
          <Redirect to={props.defaultRedirect} />
        </Route>
        }

      </Switch>
    </BrowserRouter>
    <AppSpinner />
  </>
}

